import { Event_ } from '../Event_';
export class FormEvent_ extends Event_ {
    get key() {
        return this.reactEvent.key;
    }
    get inputValue() {
        return this.reactEvent.target.value;
    }
}
